import type { TaskStatus } from '@/tasks/task';

/**
 * 状況ごとの配色。
 *
 * 赤×緑は使わない（色覚多様性への配慮）。進行中だけを青系で立たせ、未着手は
 * ニュートラル、対応済は退かせることで「いま手を付けているもの」が最も目に入る。
 * @graph-connects none
 */
export const STATUS_CLASS: Record<TaskStatus, string> = {
  未着手:
    'border-[var(--color-todo-border)] bg-[var(--color-todo-bg)] text-[var(--color-todo-text)]',
  対応中:
    'border-[var(--color-doing-border)] bg-[var(--color-doing-bg)] text-[var(--color-doing-text)]',
  対応済:
    'border-[var(--color-done-border)] bg-[var(--color-done-bg)] text-[var(--color-done-text)]',
};

/**
 * StatusBadge の props。
 */
export interface StatusBadgeProps {
  /** 表示する状況 */
  status: TaskStatus;
}

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business タスクの状況をバッジで示す。進行中を青系で立たせ、対応済は退かせる
 * @graph-connects none
 */
export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full border px-2 py-0.5 text-xs whitespace-nowrap ${STATUS_CLASS[status]}`}
    >
      {status}
    </span>
  );
}
